import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import router from './router'

import VueRouter from 'vue-router'

//Custom helpers
import '@/auth/jwt/useJwt'
import axiosInterceptors from '@/helpers/axios';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

import './assets/scss/style.scss'

Vue.use(VueRouter)

// Redirection automatique vers commissaire-justice.fr si on est sur huissier-justice.fr
const currentDomain = window.location.hostname;
if (currentDomain === 'inscription-securact.huissier-justice.fr') {
  const newUrl = window.location.href.replace(
    'inscription-securact.huissier-justice.fr',
    'inscription-securact.commissaire-justice.fr'
  );
  window.location.href = newUrl;
}

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueToast, {
  // One of the options
  position: 'bottom-right'
})

//Custom helpers registration
axiosInterceptors()

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
